import { Component, Input, OnInit } from '@angular/core';
import { NavItemModel } from './models/nav-item.model';

@Component({
  selector: 'app-nav-item-list',
  templateUrl: './nav-item-list.component.html',
})
export class NavItemListComponent implements OnInit {
  @Input() items?: NavItemModel[];
  @Input() toUpperCase = false;

  constructor() {}

  ngOnInit(): void {}
}
